/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SpendingModel { 
    id: number;
    organizationId: number;
    storeId: number;
    spendCategoryCode: string;
    total: number;
    date: string;
    incomingNumber?: string;
    paidDate?: string;
    cashFlowCategoryCode?: string;
    payBefore: string;
}

